import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Trophy } from "lucide-react";

export default function MyPrograms() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/me/enrolments").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="my-programs" className="px-4 md:px-8 pb-16 pt-2">
      <h1 className="font-display font-900 uppercase text-4xl md:text-5xl tracking-tight">My Programs</h1>
      <p className="text-muted-foreground mt-1">Paid programs you're enrolled in.</p>
      {items.length === 0 && (
        <div className="mt-8 border border-border rounded-xl bg-card p-8 text-center">
          <Trophy className="text-primary mx-auto" size={30} />
          <p className="mt-3 font-bold">You haven't joined a paid program yet.</p>
          <Link to="/programs/6-day-bodyweight-challenge" className="inline-block mt-4 bg-primary text-primary-foreground px-6 py-3 rounded-full text-xs uppercase font-bold">Join 6-Day Challenge</Link>
        </div>
      )}
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 mt-6">
        {items.map((e) => (
          <Link key={e.id} to={`/app/programs/${e.id}`} data-testid="enrolment-card" className="group border border-border rounded-xl bg-card overflow-hidden hover:border-primary transition-colors">
            {e.program?.thumbnail ? <img src={e.program.thumbnail} className="w-full aspect-video object-cover" alt="" /> : <div className="w-full aspect-video bg-gradient-to-br from-primary/30 to-black/40" />}
            <div className="p-5">
              <span className={`text-[10px] uppercase font-bold ${e.status === "active" ? "text-primary" : "text-muted-foreground"}`}>{e.status}</span>
              <h3 className="font-display font-700 uppercase text-2xl tracking-tight mt-1">{e.program?.title}</h3>
              <div className="text-xs text-muted-foreground mt-1">Level: {e.level} · {e.language}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
